import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const orgStructureLevel = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Name of the organizational level.'),

    description: z
      .string()
      .nullable()
      .optional()
      .describe('Description of what this level represents.'),

    organizations: hasMany('Organization', 'orgStructureLevelId'),
  })
  .describe(
    'Defines a tier in the organizational hierarchy, such as division or department.',
  )
  .as('OrgStructureLevel');

export { orgStructureLevel as orgStructureLevelSchema };
